import { __awaiter, __extends, __generator } from "tslib";
import { ElementCategory, ElementChangedFlags, NodeUserData, SceneElement } from "../core/mdl";
import { PropertyChangedResult } from "../core/prop";
import * as basket from "../eaiws/basket";
import { Lock } from "../utils/async";
import { ERR_INVALID_ARGUMENT, ERR_INVALID_STATE, newError, rejectError } from "../utils/error";
import { Interactors } from "./oap/Interactors";
import { ArticlePropertyHelpers, SubArticleElement } from "./main";
var ArticleElement = /** @class */ (function (_super) {
    __extends(ArticleElement, _super);
    function ArticleElement(pBasketId, pManager, pNode) {
        var _this = _super.call(this, pManager.app.model, pNode) || this;
        _this.onSetPropertyValue = function (pEaiProperty, pValue) {
            if (pEaiProperty == null)
                return (Promise.resolve(PropertyChangedResult.Nothing));
            var tStrValue = null;
            if (pValue != null)
                tStrValue = pValue.toString();
            return (_this.setEaiwsPropertyValue(pEaiProperty.propClass, pEaiProperty.propName, tStrValue, true));
        };
        _this.mBasketId = pBasketId;
        _this.mRecoveryBasketId = pBasketId;
        _this.mMngr = pManager;
        _this.mOapInteractors = new Interactors(_this, _this.mMngr);
        _this.mArticleDataLock = new Lock();
        //register added/removed events
        _this.eventAdded.addListener(function () { return _this.mMngr.eventArticleAdded.trigger(_this); });
        _this.eventRemoved.addListener(function () { return _this.mMngr.eventArticleRemoved.trigger(_this); });
        return _this;
    }
    Object.defineProperty(ArticleElement.prototype, "basketId", {
        /**
         * BasketId may be null if the article is not intantiated yes (use ensureIsInstanced()).
         * e.g. if article is a newly created clone
         */
        get: function () {
            return (this.mBasketId);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ArticleElement.prototype, "category", {
        get: function () {
            return (ElementCategory.Interior);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ArticleElement.prototype, "hasGeometry", {
        /**
         * Returns false if the article (including its children) has no or an empty geometry.
         */
        get: function () {
            return (this.boundingBox.isValid());
        },
        enumerable: false,
        configurable: true
    });
    ArticleElement.prototype.showInteractors = function (pShow) {
        this.mOapInteractors.showInteractors(pShow);
    };
    ArticleElement.prototype.dispose = function () {
        _super.prototype.dispose.call(this);
        this.mOapInteractors.dispose();
    };
    /**
     * Retrieves the article data for this article.
     * In order to retrieve the properties, the article has to be instantiated
     * on server side. This may not be possible if the ofml data is not installed or it has changed
     * (article requires migration). The operation would fail in those cases. If properties are not
     * required the noProperties option can be set to true to avoid this. (Default: false)
     */
    ArticleElement.prototype.getArticleData = function (pOptions) {
        return __awaiter(this, void 0, void 0, function () {
            var tLock, tData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.ensureIsInstanced()];
                    case 1:
                        _a.sent();
                        if (this.mBasketId == null)
                            throw newError(ERR_INVALID_STATE, "basketId is null");
                        return [4 /*yield*/, this.mArticleDataLock.acquireLock()];
                    case 2:
                        tLock = _a.sent();
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, , 5, 6]);
                        return [4 /*yield*/, this.getMainArticle()._getArticleData(this.mBasketId, pOptions)];
                    case 4:
                        tData = _a.sent();
                        return [2 /*return*/, (tData)];
                    case 5:
                        tLock.unlock();
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    ArticleElement.prototype.getCachedArticleData = function (pOptions) {
        if (this.mBasketId == null)
            return (undefined);
        return (this.getMainArticle()._getCachedArticleData(this.mBasketId, pOptions));
    };
    ArticleElement.prototype.getBasketItem = function () {
        var _this = this;
        var tPromise = this.ensureIsInstanced().then(function () {
            if (_this.mBasketId == null)
                return (rejectError(ERR_INVALID_STATE, "basketId is null"));
            return (_this.getMainArticle()._getBasketItem(_this.mBasketId));
        });
        return (tPromise);
    };
    ArticleElement.prototype.getCachedBasketItem = function () {
        if (this.mBasketId == null)
            return (undefined);
        return (this.getMainArticle()._getCachedBasketItem(this.mBasketId));
    };
    ArticleElement.prototype.getItemProperties = function () {
        var _this = this;
        var tPromise = this.ensureIsInstanced().then(function () {
            if (_this.mBasketId == null)
                return (rejectError(ERR_INVALID_STATE, "basketId is null"));
            return (_this.getMainArticle()._getItemProperties(_this.mBasketId));
        });
        return (tPromise);
    };
    ArticleElement.prototype.getCachedItemProperties = function () {
        if (this.mBasketId == null)
            return (undefined);
        return (this.getMainArticle()._getCachedItemProperties(this.mBasketId));
    };
    ArticleElement.prototype.getCalculation = function () {
        var _this = this;
        var tPromise = this.ensureIsInstanced().then(function () {
            if (_this.mBasketId == null)
                return (rejectError(ERR_INVALID_STATE, "basketId is null"));
            return (_this.getMainArticle()._getCalculation(_this.mBasketId));
        });
        return (tPromise);
    };
    ArticleElement.prototype.getCachedCalculation = function () {
        if (this.mBasketId == null)
            return (undefined);
        return (this.getMainArticle()._getCachedCalculation(this.mBasketId));
    };
    ArticleElement.prototype.getCachedConfigData = function () {
        if (this.mBasketId == null)
            return (undefined);
        return (this.getMainArticle()._getCachedConfigData(this.mBasketId));
    };
    ArticleElement.prototype.getCatalogImage = function () {
        var _this = this;
        var tPromise = this.ensureIsInstanced().then(function () {
            if (_this.mBasketId == null)
                return (rejectError(ERR_INVALID_STATE, "basketId is null"));
            return (_this.getMainArticle()._getCatalogImage(_this.mBasketId));
        });
        return (tPromise);
    };
    ArticleElement.prototype.getSubArticles = function (pDirectOnly) {
        var tSubArticles = new Array();
        this.collectSubArticles(this.mNode, tSubArticles, pDirectOnly);
        return (tSubArticles);
    };
    ArticleElement.prototype.getSubArticleById = function (pBasketId) {
        return (this.findSubArticle(this.mNode, pBasketId));
    };
    ArticleElement.prototype.setEaiwsPropertyValue = function (pPropClass, pPropName, pValue, pUpdateGeometry) {
        return __awaiter(this, void 0, void 0, function () {
            var tOtherArticleChanged, tResult, tMainArticle, tArticleRemoved, tMainArticle, tSubArticles, _i, tSubArticles_1, tSub;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.ensureIsInstanced()];
                    case 1:
                        _a.sent();
                        if (this.mBasketId == null)
                            throw newError(ERR_INVALID_STATE, "basketId is null");
                        tOtherArticleChanged = false;
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, , 8, 9]);
                        this.mModel.beginModification();
                        this.beginPropertyChange();
                        return [4 /*yield*/, this.mMngr.session.basket.setPropertyValue(this.mBasketId, pPropClass, pPropName, pValue)];
                    case 3:
                        tResult = _a.sent();
                        if (!(tResult != null && tResult !== "U")) return [3 /*break*/, 6];
                        tMainArticle = this.getMainArticle();
                        tOtherArticleChanged = tResult.indexOf("u") !== -1; //other item changed
                        tArticleRemoved = tResult.indexOf("r") !== -1;
                        tMainArticle._clearCachedArticleInfo(this, tOtherArticleChanged);
                        this.notifyChange(ElementChangedFlags.Properties);
                        if (!pUpdateGeometry) return [3 /*break*/, 5];
                        return [4 /*yield*/, tMainArticle.updateGeometry(tArticleRemoved)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5:
                        this.mMngr._notifyArticleChanged(tOtherArticleChanged ? tMainArticle : this, tOtherArticleChanged);
                        return [2 /*return*/, (PropertyChangedResult.Properties)];
                    case 6: return [2 /*return*/, (PropertyChangedResult.Nothing)];
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        //notify property change for whole composite
                        if (tOtherArticleChanged) {
                            tMainArticle = this.getMainArticle();
                            tSubArticles = tMainArticle.getSubArticles(false);
                            tMainArticle.notifyChange(ElementChangedFlags.Properties);
                            for (_i = 0, tSubArticles_1 = tSubArticles; _i < tSubArticles_1.length; _i++) {
                                tSub = tSubArticles_1[_i];
                                tSub.notifyChange(ElementChangedFlags.Properties);
                            }
                        }
                        this.endPropertyChange();
                        this.mModel.endModification();
                        return [7 /*endfinally*/];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    ArticleElement.prototype.getProperties = function () {
        var _this = this;
        /*prevent unknown item id exception
            We do this here to make it easier for the host application to handle cases where
            this article itself gets deleted after changing a property. This may be the case for sub-articles. */
        if (this.isDisposed)
            return (Promise.resolve(null));
        if (!this.mMngr.session.isValid)
            return (Promise.resolve(null));
        var tPromise = this.getArticleData().then(function (pData) {
            return (ArticlePropertyHelpers.GetProperties(_this.basketId, _this.mMngr.session, _this, pData, _this.onSetPropertyValue));
        });
        return (tPromise);
    };
    ArticleElement.prototype.getPropertyClasses = function () {
        /*prevent unknown item id exception
            We do this here to make it easier for the host application to handle cases where
            this article itself gets deleted after changing a property. This may be the case for sub-articles. */
        if (this.isDisposed)
            return (Promise.resolve(null));
        if (!this.mMngr.session.isValid)
            return (Promise.resolve(null));
        var tPromise = this.getArticleData().then(function (pData) {
            return (ArticlePropertyHelpers.GetPropertyClasses(pData));
        });
        return (tPromise);
    };
    /**
     * Returns true if this article has interactors. E.g. OAP interactors.
     */
    ArticleElement.prototype.hasInteractors = function () {
        return __awaiter(this, void 0, void 0, function () {
            var tInteractors;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getMainArticle()._getOapInteractors(this)];
                    case 1:
                        tInteractors = _a.sent();
                        return [2 /*return*/, (tInteractors != null && tInteractors.length > 0)];
                }
            });
        });
    };
    ArticleElement.GetEaiwsProperty = function (pProperty) {
        var tUserData = ArticlePropertyHelpers.GetPropertyUserData(pProperty);
        return (tUserData == null ? null : tUserData.eaiwsProperty);
    };
    //// internal //////////////////////////////////////////////////////////////////////////////
    /** @internal */
    ArticleElement.prototype._setBasketId = function (pBasketId) {
        this.mBasketId = pBasketId;
        this.mRecoveryBasketId = pBasketId;
        NodeUserData.SetData(this.mNode, ArticleElement.NODEDATA_BASKETID, pBasketId);
    };
    /** @internal */
    ArticleElement.prototype._getRecoveryBasketId = function () {
        return (this.mRecoveryBasketId);
    };
    /** @internal */
    ArticleElement._GetOfmlUpdateState = function (pSession, pBasketId) {
        if (pSession == null || pBasketId == null)
            return (Promise.reject(new Error(ERR_INVALID_ARGUMENT)));
        //query state
        var tOptions = new basket.UpdateBasketArticlesOptions();
        tOptions.migrate = false;
        tOptions.update = false;
        var tPromise = pSession.basket.updateBasketArticles([pBasketId], null, tOptions).then(function (pResult) {
            if (pResult != null && pResult.length > 0)
                return (pResult[0].updateState);
            else
                return ("Unknown");
        });
        return (tPromise);
    };
    ArticleElement.prototype.copyDataFrom = function (pElement) {
        _super.prototype.copyDataFrom.call(this, pElement);
        if (pElement == null || !(pElement instanceof ArticleElement))
            return;
        var tOther = pElement;
        this.mRecoveryBasketId = tOther.mRecoveryBasketId;
    };
    ArticleElement.prototype.collectSubArticles = function (pParent, pArticles, pDirectOnly) {
        if (pParent == null)
            return;
        var tChilds = pParent.getChildTransformNodes(true);
        for (var _i = 0, tChilds_1 = tChilds; _i < tChilds_1.length; _i++) {
            var tChild = tChilds_1[_i];
            var tCollectChilds = true;
            var tElement = SceneElement.FromNode(tChild, false);
            if (tElement != null && tElement instanceof SubArticleElement) {
                pArticles.push(tElement);
                tCollectChilds = !pDirectOnly;
            }
            if (tCollectChilds)
                this.collectSubArticles(tChild, pArticles, pDirectOnly);
        }
    };
    ArticleElement.prototype.findSubArticle = function (pParent, pBasketId) {
        if (pParent == null)
            return (null);
        var tFoundArticle = null;
        var tChilds = pParent.getChildTransformNodes(true);
        for (var _i = 0, tChilds_2 = tChilds; _i < tChilds_2.length; _i++) {
            var tChild = tChilds_2[_i];
            var tElement = SceneElement.FromNode(tChild, false);
            if (tElement != null && tElement instanceof SubArticleElement &&
                tElement.basketId === pBasketId) {
                tFoundArticle = tElement;
                break;
            }
            else {
                tFoundArticle = this.findSubArticle(tChild, pBasketId);
                if (tFoundArticle != null)
                    break;
            }
        }
        return (tFoundArticle);
    };
    ArticleElement.NODEDATA_BASKETID = "cf:basketId";
    ArticleElement.NODEDATA_SELECTABLE = "cf:selectable";
    return ArticleElement;
}(SceneElement));
export { ArticleElement };
